import { signOrder } from "../api";


const domainId = "?domainId=4";
const apiConfig = {
  /*上传*/
  commonApi: {
    bfileup: "_apigateway/zhsf/person/api/view/upload.rst",
    fileup: "_fileup",

    downfile: "/_utils/download/downloadResource.rst" + domainId + "&objType=CommonDownload&storedMode=d",
  },
  userApi: {
    login: "_bases/sso/api/login.rst" + domainId,
    phonelogin: "_apigateway/zhsf/person/api/sso/login.rst" + domainId,
    resetPassword: "_apigateway/zhsf/person/api/sso/resetPassword.rst" + domainId,
    register: "_apigateway/zhsf/person/api/sso/v1/add.rst" + domainId,
    updateperson: "_apigateway/zhsf/person/api/v1/update.rst" + domainId,
    userinfo: "_apigateway/sso/api/v1/info.rst" + domainId,
    personinfo: "_apigateway/zhsf/person/api/v1/info.rst" + domainId,
    loginout: "_customs/hhs/zhsf/sso/logout.jsp" + domainId,
    usermsg: "_apigateway/zhsf/message/api/messages.rst" + domainId,
    usermsgread: "_apigateway/zhsf/message/api/addReader.rst" + domainId,
    userpwd: "_apigateway/zhsf/person/api/update.rst" + domainId,
    bookcate: "_apigateway/zhsf/type/api/view/v1/types.rst" + domainId,
    validatecode: "",
    booklists: "_apigateway/zhsf/book/api/view/v1/books.rst",
    bookdetail: "_apigateway/zhsf/book/api/view/v1/book.rst",
    getaddress: "_apigateway/zhsf/person/api/address/v1/addresses.rst",
    addaddress: "_apigateway/zhsf/person/api/address/v1/create.rst",
    updateaddress: "_apigateway/zhsf/person/api/address/v1/update.rst",
    sendSmsCode: "_apigateway/zhsf/person/api/sso/sendacode.rst" + domainId,
    getArticle: "_agw/article/view/api/v1/articles.rst" + domainId,
    getArticledetail: "_agw/article/view/api/v1/article.rst" + domainId,
  },
  cartApi: {
    getCartList: "_apigateway/zhsf/cart/api/v1/carts.rst",
    addCart: "_apigateway/zhsf/cart/api/v1/create.rst",
    updateCart: "_apigateway/zhsf/cart/api/v1/update.rst",
    delCart: "_apigateway/zhsf/cart/api/v1/remove.rst" + domainId,
    clearCart: "_apigateway/zhsf/cart/api/v1/clear.rst" + domainId,
  },
  orderApi: {
    getOrderList: "_apigateway/zhsf/order/api/v1/orders.rst" + domainId,
    addOrder: "_apigateway/zhsf/order/api/v1/create.rst" + domainId,
    getPayOrderCheck: "_apigateway/zhsf/order/api/v1/check.rst" + domainId,
    getPayOrderDetail: "_apigateway/zhsf/order/api/v1/order.rst" + domainId,
    signOrder: "_apigateway/zhsf/order/api/v1/signfor.rst" + domainId,
    cancelOrder: "_apigateway/zhsf/order/api/v1/cancel.rst" + domainId,
  },
};

export default apiConfig;



// WEBPACK FOOTER //
// ./src/request/baseConfig/apiConfig.js